import axiosInstance from '../../Config/axiosConfig';

export const joinAffiliate = async () => {
  try {
    const { data } = await axiosInstance.post('/user/affiliate/join');
    return data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};

export const getAffiliateDashboard = async () => {
  try {
    const { data } = await axiosInstance.get('/user/affiliate/dashboard');
    return data.data ?? data;
  } catch (error) {
    throw error.response
      ? { ...error.response.data, status: error.response.status }
      : { message: 'Unknown error occurred' };
  }
};

export const getAffiliateBankAccount = async () => {
  try {
    const { data } = await axiosInstance.get('/user/affiliate/bank-account');
    const payload = data.data ?? data;
    return payload?.bank_account ?? null;
  } catch (error) {
    throw error.response
      ? { ...error.response.data, status: error.response.status }
      : { message: 'Unknown error occurred' };
  }
};

export const saveAffiliateBankAccount = async (payload) => {
  try {
    const { data } = await axiosInstance.post('/user/affiliate/bank-account', payload);
    return data;
  } catch (error) {
    throw error.response
      ? error.response.data
      : { message: 'Unknown error occurred' };
  }
};
